import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/jinjunfu/gold',
    name: 'gold',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/jinjunfu/GoldView.vue')
  },
  {
    path: '/jinjunfu/wxMinShop',
    name: 'wxMinShop',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/jinjunfu/WxMinShopView.vue')
  },
  {
    path: '/closingLine/cutGood',
    name: 'cutGood',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/CutGood.vue')
  },
  {
    path: '/closingLine/goodDetails',
    name: 'goodDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/GoodDetails.vue')
  },
  {
    path: '/closingLine/purchaseInfo',
    name: 'purchaseInfo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/PurchaseInfo.vue')
  },
  {
    path: '/closingLine/carehouseList',
    name: 'carehouseList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/CarehouseList.vue')
  },
  {
    path: '/closingLine/godownInfor',
    name: 'godownInfor',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/GodownInfor.vue')
  },
  {
    path: '/closingLine/purchaseList',
    name: 'purchaseList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/PurchaseList.vue')
  },
  {
    path: '/closingLine/buyDetails',
    name: 'buyDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/BuyDetails.vue')
  },
  {
    path: '/closingLine/buyRecords',
    name: 'buyRecord',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/BuyRecord.vue')
  },
  {
    path: '/closingLine/buyStatus',
    name: 'buyStatus',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/BuyStatus.vue')
  },
  {
    path: '/closingLine/paymentInfor',
    name: 'paymentInfor',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/PaymentInfor.vue')
  },
  {
    path: '/closingLine/purchaseAgreement',
    name: 'purchaseAgreement',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/PurchaseAgreement.vue')
  },
  {
    path: '/closingLine/pendingAgreement',
    name: 'pendingAgreement',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/PendingAgreement.vue')
  },
  {
    path: '/closingLine/salesAgreement',
    name: 'salesAgreement',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/SalesAgreement.vue')
  },
  {
    path: '/closingLine/SignView',
    name: 'signView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/closingLine/SignView.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
